import React, { ReactNode, useState, useEffect } from 'react';
import { useQuery } from '@apollo/react-hooks';
import QUERY_FILTER_LAST_MILE_QUERY, {
  QueryFilterLastMileData,
  LastMileList,
} from 'shared/graphql/query/queryFilterLastMile';
import { Select, message } from 'antd';
import useMessageError from 'shared/hooks/useMessageError';

type SelectMultiLastMileProps = {
  value?: string[];
  disabled?: boolean;
  onChange?: (values: string[]) => void;
};

const { Option } = Select;

const SelectMultiLastMile: React.FC<SelectMultiLastMileProps> = (props) => {
  const { value, disabled, onChange } = props;
  const [lastMileList, setLastMileList] = useState<LastMileList>([]);
  const { getMessageError } = useMessageError();

  const { data, loading, error } = useQuery<QueryFilterLastMileData>(QUERY_FILTER_LAST_MILE_QUERY, {
    onError: (err) => {
      message.error(getMessageError(err));
    },
    fetchPolicy: 'cache-and-network',
  });

  useEffect(() => {
    if (!loading && !error && data?.queryFilterLastMile) {
      setLastMileList([...data.queryFilterLastMile.lastMileList]);
    }
  }, [data?.queryFilterLastMile, loading, error]);

  const options: ReactNode[] = lastMileList.map((item) => {
    return <Option key={item} value={item}>{`${item}`}</Option>;
  });

  return (
    <Select
      allowClear
      mode="multiple"
      maxTagCount="responsive"
      value={value}
      disabled={disabled}
      loading={loading}
      placeholder="ค้นหา"
      onChange={(valueChange) => {
        onChange && onChange(valueChange);
      }}
      showSearch
      optionFilterProp="children"
      filterOption={(input, option) =>
        option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      style={{ width: '100%' }}
    >
      {options}
    </Select>
  );
};

export default SelectMultiLastMile;
